export function getEmployeeCount(companyData) {
  const resourceCount = companyData?.resourceCounts?.employeesCount;
  if (typeof resourceCount === 'number') {
    return resourceCount;
  }

  const legacyCount = companyData?.employeesCount;
  if (typeof legacyCount === 'number') {
    return legacyCount;
  }

  return 0;
}

export function hasAddedEmployees(companyData) {
  return getEmployeeCount(companyData) > 1;
}
